import {filter, find, groupBy, isEmpty, keyBy} from 'lodash';
import {useEffect,useState} from 'react';
import {useLocation} from 'react-router-dom';
import {Stack,Container,Typography} from '@mui/material';
import Page from '../components/Page';
import axios from 'axios';
import {API_URL} from '../constant';
import moment from 'moment';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

export default function LoanDetails() {    
    const location = useLocation();
    const { loanDetails } = location.state || {}
    const loanId = loanDetails?.loan_id;
    const customerId = loanDetails?.customer_id;
    const dealerId = loanDetails?.dealer_id
    const [loanMembersKycDetails, setLoanMembersKycDetails] = useState([])
    const [loanDeviation, setLoanDeviation] = useState([])
    const [vehicleRc,setVehicleRc] = useState({})
    const [vehicleInsurance,setVehicleInsurance] = useState({})
    const [vehicleInvoice, setVehicleInvoice] = useState({})
    const [dealerPaymentDetails, setDealerPaymentDetails] = useState([])
    const [dealerHoldAmount, setdDealerHoldAmount] = useState({})

    useEffect(() => {
        if (customerId && loanId) {
            fetchLoanMemberKycStatus();
        }
    }, [customerId, loanId]);

    useEffect(() => {
        if (customerId && loanId) {
            fetchPddDetails();
        }
    }, [customerId, loanId]);

    useEffect(() => {
        if (customerId && loanId) {
            fecthVehicleRelatedDocs();
        }
    }, [customerId, loanId]);

    useEffect(() => {
        if (dealerId && loanId) {
            dealerPaymentStatus();
        }
    }, [dealerId, loanId]);

    const fetchLoanMemberKycStatus = async() => {
        const result = await axios.get(`${API_URL}/customer/${customerId}/loan/${loanId}/loan_members`);
        const allMembersKycs = result?.data?.data
        if(!isEmpty(allMembersKycs)){
            setLoanMembersKycDetails(allMembersKycs)
        }
    }

    const fetchPddDetails = async() => {
        const result = await axios.get(`${API_URL}/customer/${customerId}/loan/${loanId}/deviation`);
        const loanDeviations = result?.data?.data
        if(!isEmpty(loanDeviations)){
            setLoanDeviation(loanDeviations)
        }
    }

    const fecthVehicleRelatedDocs = async() => {
        const result = await axios.get(`${API_URL}/loan/${loanId}/vehicle_docs`);
        const vehicleRelatedDocs = result?.data?.data
        if(!isEmpty(vehicleRelatedDocs)){
            const {vehicleInsurance,vehicleInvoice,vehicleRc} = vehicleRelatedDocs
            const vehicleInsuranceData = vehicleInsurance ? vehicleInsurance[0] : []
            const vehicleInvoiceData = vehicleInvoice ? vehicleInvoice[0] : []
            setVehicleRc(vehicleRc)
            setVehicleInsurance(vehicleInsuranceData)
            setVehicleInvoice(vehicleInvoiceData)
        }
    }

    const dealerPaymentStatus = async() => {
        const result = await axios.get(`${API_URL}/dealer/${dealerId}/loan/${loanId}/dealer_payment_details`);
        const dealerPayment = result?.data?.data
        if(!isEmpty(dealerPayment)){
            const rcSecurotyHold = find(dealerPayment,{loan_ledger_type:'rc security hold'})
            const dealerPaymentDetails = dealerPayment.filter(payment => payment.loan_ledger_type === 'dealer payment')
            setDealerPaymentDetails(dealerPaymentDetails)
            setdDealerHoldAmount(rcSecurotyHold)
        }
    }

    return (
        <Page>
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={1} mt={1}>
                    <Typography sx={{color:'#5c5c5c'}} variant="h5" gutterBottom>
                        Loan Details - {loanDetails?.loan_id} - {loanDetails?.type}
                    </Typography>
                </Stack>
                <div style={{display:'flex',flexDirection:'row', justifyContent:'space-between',alignItems:'center',marginLeft:20}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexBasis:'30%'}}>
                        <p style={{fontSize:16,fontWeight:'bold'}}>Customer Name :</p>
                        <p style={{}}>{loanDetails?.customer_name}</p>
                    </div>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexBasis:'30%'}}>
                        <p style={{fontSize:16,fontWeight:'bold'}}>Loan Amount :</p>
                        <p style={{}}>{loanDetails?.amount}</p>
                    </div>
                </div>
                <div style={{display:'flex',flexDirection:'row', justifyContent:'space-between',alignItems:'center',marginLeft:20}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexBasis:'30%'}}>
                        <p style={{fontSize:16,fontWeight:'bold'}}>Loan Type :</p>
                        <p style={{}}>{loanDetails?.type}</p>
                    </div>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexBasis:'30%'}}>
                        <p style={{fontSize:16,fontWeight:'bold'}}>Tenure :</p>
                        <p style={{}}>{loanDetails?.disburse_tenure}</p>
                    </div>
                </div>
                <div style={{display:'flex',flexDirection:'row', justifyContent:'space-between',alignItems:'center',marginLeft:20}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexBasis:'30%'}}>
                        <p style={{fontSize:16,fontWeight:'bold'}}>EMI AMount :</p>
                        <p style={{}}>{loanDetails?.disburse_emi}</p>
                    </div>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexBasis:'30%'}}>
                        <p style={{fontSize:16,fontWeight:'bold'}}>Loan State :</p>
                        <p style={{}}>{loanDetails?.state}</p>
                    </div>
                </div>
                <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={1} mt={2}>
                    <Typography sx={{textDecoration:'underline',color:'#5c5c5c'}} variant="h6" gutterBottom>
                        KYC Related Documents
                    </Typography>
                </Stack>
                {!isEmpty(loanMembersKycDetails) ? loanMembersKycDetails?.map((kyc,index) => {
                    if(kyc.relation_id === 0){
                        return <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                                <div style={{display:'flex',flexDirection:'column', justifyContent:'flex-start',flexBasis:'30%',marginLeft:20}}>
                                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                                        <p style={{fontSize:16,fontWeight:'bold'}}>Aadhaar Verified :</p>
                                        <p style={{color : kyc?.is_verified_by_karza_aadhaar ? 'green' : 'orange'}}>{kyc?.is_verified_by_karza_aadhaar ? 'Verified' : 'Pending'}</p>
                                    </div>
                                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                                        <p style={{fontSize:16,fontWeight:'bold'}}>Aadhaar Upload :</p>
                                        <p style={{color : kyc?.aadhaar_doc_id ? 'green' : 'orange'}}>{kyc?.aadhaar_doc_id ? 'Uploaded' : 'Pending'}</p>
                                    </div>
                                </div>
                                <div style={{display:'flex',flexDirection:'column', justifyContent:'flex-start',flexBasis:'30%'}}>
                                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center', flexBasis:'30%'}}>
                                        <p style={{fontSize:16,fontWeight:'bold'}}>PAN Verified :</p>
                                        <p style={{color : kyc?.is_verified_by_karza_pan ? 'green' : 'orange'}}>{kyc?.is_verified_by_karza_pan ? 'Verified' : 'Pending'}</p>
                                    </div>
                                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center', flexBasis:'30%'}}>
                                        <p style={{fontSize:16,fontWeight:'bold'}}>PAN Upload :</p>
                                        <p style={{color : kyc?.pan_doc_id ? 'green' : 'orange'}}>{kyc?.pan_doc_id ? 'Uploaded' : 'Pending'}</p>
                                    </div>
                                </div>
                        </div>
                    }
                }) : <p>No Kyc Uploaded</p>}
                {!isEmpty(loanDeviation) && <div>
                    <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={1} mt={2}>
                    <Typography sx={{textDecoration:'underline',color:'#5c5c5c'}} variant="h6" gutterBottom>
                        PDD Details
                    </Typography>
                </Stack>
                {loanDeviation.map((deviation,index) => {
                    return <div>
                        <div style={{display:'flex', flexDirection:'row',marginLeft:20}}>
                            <p>{index+1}.</p>
                            <p style={{marginLeft:10}}>{deviation?.code.toUpperCase()}</p>
                            <p style={{marginLeft:20}}>{deviation?.created_at ? moment(deviation?.created_at).format('DD-MM-YYYY') : "--"}</p>
                        </div>
                    </div>
                })}
                </div>}
                {(!isEmpty(vehicleInvoice) || !isEmpty(vehicleInsurance) || !isEmpty(vehicleRc)) && <div><Stack direction="row" alignItems="center" justifyContent="flex-start" mb={1} mt={2}>
                    <Typography sx={{textDecoration:'underline',color:'#5c5c5c'}} variant="h6" gutterBottom>
                        Vehicle Related Documents
                    </Typography>
                </Stack>
                {!isEmpty(vehicleInvoice) && <div style={{display:'flex', flexDirection:'column',marginLeft:20}}>
                    <div style={{display:'flex', flexDirection:'row'}}>
                        <div style={{flexBasis:'30%'}}>
                            <p style={{fontWeight:'bold'}}>Vehicle Invoice</p>
                        </div>
                        <div style={{flexBasis:'30%'}}>
                            <p style={{color : vehicleInvoice?.doc_id ? 'green' : 'orange'}}>{vehicleInvoice?.doc_id ? 'Uploaded' : 'Pending'}</p>
                        </div>
                        <div style={{display:'flex', flexBasis:'30%', flexDirection:'row'}}>
                            {vehicleInvoice?.doc_id ? <CloudDownloadIcon /> : <CloudUploadIcon />}<p style={{cursor:'pointer',marginLeft:10, color:vehicleInvoice?.doc_id ? 'green' : 'orange'}}>{vehicleInvoice?.doc_id ? 'Download Invoice' : 'Upload Invoice'}</p>
                        </div>
                    </div>
                </div>}
                {!isEmpty(vehicleRc) && <div style={{display:'flex', flexDirection:'column',marginLeft:20}}>
                    <div style={{display:'flex', flexDirection:'row'}}>
                        <div style={{flexBasis:'30%'}}>
                            <p style={{fontWeight:'bold'}}>Vehicle RC</p>
                        </div>
                        <div style={{flexBasis:'30%'}}>
                            <p style={{color : vehicleRc?.rc_file_path ? 'green' : 'orange'}}>{vehicleRc?.rc_file_path ? 'Uploaded' : 'Pending'}</p>
                        </div>
                        <div style={{display:'flex', flexBasis:'30%', flexDirection:'row'}}>
                            {vehicleRc?.rc_file_path ? <CloudDownloadIcon /> : <CloudUploadIcon />}<p style={{cursor:'pointer',marginLeft:10, color:vehicleRc?.rc_file_path ? 'green' : 'orange'}}>{vehicleRc?.rc_file_path ? 'Download RC' : 'Upload RC'}</p>
                        </div>
                    </div>
                </div>}
                {!isEmpty(vehicleRc) && <div style={{display:'flex', flexDirection:'column',marginLeft:20}}>
                    <div style={{display:'flex', flexDirection:'row'}}>
                        <div style={{flexBasis:'30%'}}>
                            <p style={{fontWeight:'bold'}}>Tax Receipt</p>
                        </div>
                        <div style={{flexBasis:'30%'}}>
                            <p style={{color : vehicleRc?.tax_receipt ? 'green' : 'orange'}}>{vehicleRc?.tax_receipt ? 'Uploaded' : 'Pending'}</p>
                        </div>
                        <div style={{display:'flex', flexBasis:'30%', flexDirection:'row'}}>
                            {vehicleRc?.tax_receipt ? <CloudDownloadIcon /> : <CloudUploadIcon />}<p style={{cursor:'pointer',marginLeft:10, color:vehicleRc?.tax_receipt ? 'green' : 'orange'}}>{vehicleRc?.tax_receipt ? 'Download Tax ' : 'Upload Tax Receipt'}</p>
                        </div>
                    </div>
                </div>}
                {!isEmpty(vehicleInsurance) && <div style={{display:'flex', flexDirection:'column',marginLeft:20}}>
                    <div style={{display:'flex', flexDirection:'row'}}>
                        <div style={{flexBasis:'30%'}}>
                            <p style={{fontWeight:'bold'}}>Vehicle Insurance</p>
                        </div>
                        <div style={{flexBasis:'30%'}}>
                            <p style={{color : vehicleInsurance?.doc_id ? 'green' : 'orange'}}>{vehicleInsurance?.doc_id ? 'Uploaded' : 'Pending'}</p>
                        </div>
                        <div style={{display:'flex', flexBasis:'30%', flexDirection:'row'}}>
                            {vehicleInsurance?.doc_id ? <CloudDownloadIcon /> : <CloudUploadIcon />}<p style={{cursor:'pointer',marginLeft:10, color:vehicleInsurance?.doc_id ? 'green' : 'orange'}}>{vehicleInsurance?.doc_id ? 'Download Insurance' : 'Upload Insurance'}</p>
                        </div>
                    </div>
                </div>}
                </div>}
                <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={1} mt={2}>
                    <Typography sx={{textDecoration:'underline',color:'#5c5c5c'}} variant="h6" gutterBottom>
                        Payment Details & Status
                    </Typography>
                </Stack>
                {!isEmpty(dealerPaymentDetails) && dealerPaymentDetails.map((payment, index) => {
                    return <div style={{display:'flex', justifyContent:'space-between',marginLeft:20,marginTop:5, fontSize:14}} key={index}>
                        <div style={{display:'flex', flexDirection:'row', flexBasis:'18%'}}>
                            <p style={{fontWeight:'bold'}}>Payment Status:</p>
                            <p style={{marginLeft:10,color:payment?.payment_ref_no ? 'green' : 'orange'}}>{payment?.payment_ref_no ? 'Done' : 'Pending'}</p>
                        </div>
                        <div style={{display:'flex', flexDirection:'row',flexBasis:'10%'}}>
                            <p style={{fontWeight:'bold'}}>Amount:</p>
                            <p style={{marginLeft:10,color:'#5c5c5c'}}>{payment?.amount}</p>
                        </div>
                        <div style={{display:'flex', flexDirection:'row',flexBasis:'28%'}}>
                            <p style={{fontWeight:'bold'}}>Payment Ref No:</p>
                            <p style={{marginLeft:10,color:'#5c5c5c'}}>{payment?.payment_ref_no ? payment?.payment_ref_no : '---'}</p>
                        </div>
                        <div style={{display:'flex', flexDirection:'row',flexBasis:'20%'}}>
                            <p style={{fontWeight:'bold'}}>Payment Date:</p>
                            <p style={{marginLeft:10,color:'#5c5c5c'}}>{payment?.ledger_date ? payment?.ledger_date : '---'}</p>
                        </div>
                        <div style={{display:'flex', flexDirection:'row',flexBasis:'20%'}}>
                            <p style={{fontWeight:'bold'}}>Payment Type:</p>
                            <p style={{marginLeft:10,color:'#5c5c5c'}}>{payment?.payment_type ? payment?.payment_type.toUpperCase() : '---'}</p>
                        </div>
                </div>
                })}
                {!isEmpty(dealerHoldAmount) && <div style={{display:'flex', flexDirection:'row',marginLeft:20,fontSize:14}}>
                    <p style={{fontWeight:'bold'}}>Hold Amount:</p>
                    <p style={{marginLeft:10, color : dealerHoldAmount?.amount ? 'orange' : '#000'}}>{dealerHoldAmount?.amount}</p>
                </div>}
            </Container>
        </Page>
    );
}
